module.exports = __webpack_public_path__ + "static/media/baseline-font.a47c4e28.svg";